import moment from "moment-timezone";
import { AppsTableData, AppsTableListItem } from "./Types";

export function getAppsTableData(data: AppsTableListItem[]): AppsTableData[] {

    if (!data) {
        return [];
    }

    return data.map((item) => {

        const timestamp = item?.status?.timestamp ? new Date(item?.status?.timestamp) : null;

        const lastModifiedDate = timestamp ? moment(timestamp).format("MM/DD/YY h:mm A")
            : "-"

        return {
            appId: item.appId,
            appIcon: item.smallIcon ?? "",
            appName: item.name,
            createdDate: "",
            lastModifiedDate,
            submitter: item?.status?.email ?? "-",
            status: item?.status?.type,
            notes: item?.status?.notes,
        };
    });
}
